import { getCurDate, getCurrentTime } from "../../utils/DateTimeUtils";
import { GetUserID } from "../../utils/common";

export interface IParseMessageRequest {
    MessageBody: string;
    Area: string;
    Phone: string;
    Date: string | Date;
    Region: string;
    CurMien: string;
    DaiQuayTrongNgay: string[];
    SpecialLexeme: string[];
    UserID: string;
    Conversation: string;
    MessageID: string;
    Type: number;
    ForceReload: string;
    Time: string;
    MessageBodyOrigin: string;
    RepeatTest: number;
    ChatID: string;
    TlUserID: string;
    TlMessageID: string;
    FromSource: string;
    TachXienMay: number;
    SoBoSo: number;
    FromBot: boolean;
    KyTuPhanTach: string;
    AreaDefault: number;
    AreaDefaultMT: number;
    DenNhuKeo: number;
    NhanDLaXien: number;
    ChoPhepLapLaiLoaiCuoc: number;
    DaToDaVong: number;
    LockArea: number;
    TachXienTheoKyTuPhanCach: number;
    TachSoDinhLienDa: number;
    TachSoDinhLienChuyenDaCap: number;
    BatBuocDongNhatDoDaiSoCuoc: number;
    KyTuNgatCung: string;
    CauTrucNhieuMucTien: number;
    KhongNhanChuDDonLe: number;
    LapLaiLoaiCuocYeuCauChiRoDonViTinhTien: number;
    RepeatReduction: number;
    Da2DaiChuyenThanhDacheo: number;
    Da3DaiChuyenThanhDacheo: number;
    DauDuoiLenTo: number;
    TinhDaoSoCo2ChuSo: number;
    KhongChapNhanSoTrungTheXien: number;
    MuonTypeSet: number;
    NhanCauTrucKhongTien: number;
    TuDongThayDoiVaiTroChuD: number;
    DungDauChamThapPhan: number;
    SendToBot: string;
    MbDvtXienNgamDinh: string;
    MbAcceptLoNghin: number;
    MbAcceptDeDiem: number;
    MbKiemTraNhapNhangXien2Xien4: number;
    MnKiemTraNhapNhangDauTruKeoDen: number;
    SoLePrefix: string;
    GetBetText: number;
    DaiBinhThuanQuayTrongNgay: boolean;
    GetRawParsedData: number;
    GetCompactData: number;
    MbYcDvtDeLonHon: number;
    MbYcDvtLoLonHon: number;
    MbYcDvtXienLonHon: number;
    YeuCauGhiDvtDe: number;
    YeuCauGhiDvtLo: number;
    XuLyDauBang: number;
    CheDoCanChuyen: number;
    ErrorCode: number;
    ErrorMsg: string;
    CheckNhapNhangSoCuocTienLe: number;
}

export function ParseMessageRequestDefaultMN() {
    return {
        MessageBody: "",
        Area: "MN.TP",
        Phone: "",
        Date: getCurDate(),
        Region: "MN",
        CurMien: "NAM",
        DaiQuayTrongNgay: [],
        SpecialLexeme: [],
        UserID: GetUserID(),
        Conversation: "",
        MessageID: "",
        Type: 1,
        ForceReload: "",
        Time: getCurrentTime(),
        MessageBodyOrigin: "",
        RepeatTest: 0,
        ChatID: "0",
        TlUserID: "0",
        TlMessageID: "0",
        FromSource: "",
        TachXienMay: 3,
        SoBoSo: 4,
        FromBot: false,
        KyTuPhanTach: "()/",
        AreaDefault: 0,
        AreaDefaultMT: 0,
        DenNhuKeo: 1,
        NhanDLaXien: 0,
        ChoPhepLapLaiLoaiCuoc: 1,
        DaToDaVong: 1,
        LockArea: 0,
        TachXienTheoKyTuPhanCach: 1,
        TachSoDinhLienDa: 1,
        TachSoDinhLienChuyenDaCap: 1,
        BatBuocDongNhatDoDaiSoCuoc: 1,
        KyTuNgatCung: ";",
        CauTrucNhieuMucTien: 0,
        KhongNhanChuDDonLe: 0,
        LapLaiLoaiCuocYeuCauChiRoDonViTinhTien: 1,
        RepeatReduction: 1,
        Da2DaiChuyenThanhDacheo: 1,
        Da3DaiChuyenThanhDacheo: 1,
        DauDuoiLenTo: 3,
        TinhDaoSoCo2ChuSo: 0,
        KhongChapNhanSoTrungTheXien: 1,
        MuonTypeSet: 1,
        NhanCauTrucKhongTien: 0,
        TuDongThayDoiVaiTroChuD: 0,
        DungDauChamThapPhan: 1,
        SendToBot: "",
        MbDvtXienNgamDinh: "n",
        MbAcceptLoNghin: 0,
        MbAcceptDeDiem: 0,
        MbKiemTraNhapNhangXien2Xien4: 1,
        MnKiemTraNhapNhangDauTruKeoDen: 1,
        SoLePrefix: "so|con",
        GetBetText: 0,
        DaiBinhThuanQuayTrongNgay: false,
        GetRawParsedData: 0,
        GetCompactData: 1,
        MbYcDvtDeLonHon: 10000,
        MbYcDvtLoLonHon: 1000,
        MbYcDvtXienLonHon: 1000,
        YeuCauGhiDvtDe: 0,
        YeuCauGhiDvtLo: 0,
        XuLyDauBang: 1,
        CheDoCanChuyen: 0,
        ErrorCode: 0,
        ErrorMsg: "",
        CheckNhapNhangSoCuocTienLe: 0,
    } as IParseMessageRequest;
}



